import React, {useEffect} from "react";
import {connect, useSelector} from "react-redux";
import {Card, CardBody, CardTitle} from "reactstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";



// components
import TranslateCountForm from "./_form";
import TranslateCountFilters from "./_filters";
import {ConfirmDelete} from "../../../components/confirmAlert/ConfirmDelete";
import {GenericTableButton} from "../../../components/buttons/buttonsActions";
import {ModalFormContainer} from "../../../components/confirmAlert/ModalFormContainer";
import {GenericButton} from "../../../components/buttons/customButtons";

// labels
import {TT_DELETE, TT_EDIT} from "../../../components/i18n/toolTips";
import {LB_ACTIONS, LB_PROJECT, LIST, NO_DATA_FOUND} from "../../../components/i18n/i18n";

// actions
import { setFilter, setTableParams, setForm, setItem } from "../../../redux/actions/generics/IndexedActions";
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";

// services
import {translateCountService} from "../../../jwt/_services/xooka/translateCountService";

// utils
import {getStateByPath} from "../../../redux/selectors";




const TranslateCountList = (props) => {
    const {path} = props
    const componentState = useSelector(state => getStateByPath(state, path));
    const {userIsAdmin, app, udn, pageSize, pageIndex, totalSize, listDomainObjects, filter} = componentState?.data || {};

    const {fbDataBase} = app

    useEffect( () => {
        if(filter)
            return

        props.setFilter(path, {
            fbDataBase,
            item: { code: null }
        })
    }, [app]);


    useEffect(() => {
        if(!filter)
            return

        genericIndexedActions.search(path, translateCountService, pageIndex, pageSize, filter)
    }, [pageIndex, pageSize, filter]);


    const editItem = data => {
        props.setItem(path, data);
        props.setForm(path, true, false, false);

        ModalFormContainer(TranslateCountForm, { path, data })
    }

    const createItem = () => {
        props.setItem(path, null);
        props.setForm(path)

        ModalFormContainer(TranslateCountForm, { path })
    }


    const confirmDelete = data => ConfirmDelete({
        path,
        data,
        fbDataBaseId: fbDataBase?.id,
        service: translateCountService,
        remove : genericIndexedActions.delete,
    } );

    const handleTableChange = (type, {page, sizePerPage}) => {
        let currentIndex = (page - 1) * sizePerPage
        props.setTableParams(path, sizePerPage, currentIndex, totalSize, currentIndex )
    };


    const columns = [
        {
            dataField: 'id',
            text: 'ID',
            hidden: true
        }, {
            dataField: 'project',
            text: `${LB_PROJECT}`,
            formatter: (cell, row) => <>{row?.project?.name}</>
        }, {
            dataField: 'monthlyCharacters',
            text: `Caracteres por mes`,
            headerStyle: {width: '180px'},
            headerAlign: 'center',
            align: 'center',
        }, {
            dataField: 'charactersToTranslate',
            text: `Caracteres disponibles`,
            headerStyle: {width: '180px'},
            headerAlign: 'center',
            align: 'center',
        }, {
            dataField: 'translatedCharacter',
            text: `Caracteres traducidos`,
            headerStyle: {width: '180px'},
            headerAlign: 'center',
            align: 'center',
        }, {
            dataField: 'actions',
            isDummyField: true,
            text: `${LB_ACTIONS}`,
            headerAlign: 'center',
            align: 'center',
            headerStyle: {width: '180px'},
            formatter: (cell, row) => <>
                <GenericTableButton toolTip={TT_EDIT} icon={'fa-pen'} permission={'edit'} onClick={() => editItem(row)}/>
                <GenericTableButton toolTip={TT_DELETE} icon={'fa-trash'} permission={'delete'} onClick={() => confirmDelete(row)}/>
            </>
        }];

    return <Card>
        <CardTitle className="bg-light border-bottom p-3 mb-0">
            <i className="far fa-list-alt mr-2"/>{LIST}
            <div className="float-right">
                <GenericButton
                    style={'table'}
                    label={'Agregar'}
                    toolTip={'Agregar'}
                    icon={'fa-plus'}
                    permission={'add'}
                    onClick={createItem}
                />
            </div>
        </CardTitle>

        <TranslateCountFilters path={path}/>

        <CardBody>
            <BootstrapTable
                striped hover
                tableHeaderClass='mb-0'
                remote
                keyField="id"
                data={listDomainObjects || []}
                columns={ columns }
                noDataIndication={NO_DATA_FOUND}
                pagination={paginationFactory({pageIndex, pageSize, totalSize})}
                onTableChange={ handleTableChange }
            />
        </CardBody>
    </Card>
}

const mapStateToProps = state => ({})
const mapActionsToProps = ({
    setFilter,
    setTableParams,
    setForm,
    setItem,
})

export default connect(mapStateToProps, mapActionsToProps)(TranslateCountList);